module.exports = __webpack_public_path__ + "static/img/首页-公司展示.8694dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/首页-公司展示.png
// module id = g1Hj
// module chunks = 16